<div class="cards-wrapper">
  <rappider-cards [items]="itemSelectorCardsConfig?.cardsConfig?.items"
                  [itemCountPerRow]="itemSelectorCardsConfig?.cardsConfig?.itemCountPerRow!"
                  [showTitleOnImage]="itemSelectorCardsConfig?.cardsConfig?.showTitleOnImage!"
                  [showDescriptionOnImage]="itemSelectorCardsConfig?.cardsConfig?.showDescriptionOnImage!"
                  [selectConfig]="itemSelectorCardsConfig?.cardsConfig?.selectConfig!"
                  [paginationConfig]="itemSelectorCardsConfig?.cardsConfig?.paginationConfig!"
                  [showCheckMarkOnCard]="itemSelectorCardsConfig?.cardsConfig?.showCheckMarkOnCard!"
                  [inputGroupConfig]="itemSelectorCardsConfig?.cardsConfig?.inputGroupConfig"
                  [clickedCardId]="selectedEntityId!"
                  (cardDetail)="onCardDetailClicked($event)"
                  (imageButtonClick)="onCardSelected($event)"></rappider-cards>
</div>
